import { useEffect, useState } from "react";
import useClientConfig from "../common/hooks/clientConfigHook";
import Signin from "../common/components/Signin";
import Button from "../common/components/Button";
import { Col, Row } from "../common/components/Grid";
import useAppState from "../common/hooks/appStateHook";
import { useNavigate } from "../common/hooks/navigateHook";

const LoginScreen = () => {
    const img = "/images/orchestrator_white.png";
    const navigate = useNavigate();
    const { token } = useAppState();
    const clientConfig = useClientConfig();
    const [mode, setMode] = useState(clientConfig.ssoPath ? 'choose' : 'local');

    useEffect(() => {
        if (token) {
            navigate('/home');
        }
    }, [token, navigate])

    useEffect(() => {
        setMode(clientConfig?.ssoPath ? 'choose' : 'local');
    }, [clientConfig.ssoPath]);


    if (mode === 'choose') {
        return <div className="my-4" style={{ margin: 'auto', maxWidth: '300px' }}>
            <Row className="mb-4">
                <Col>
                    <img alt="" src={img} style={{ maxWidth: '300px' }}></img>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Button className="w-100" onClick={() => setMode('local')} style={{ backgroundColor: '#0AAEEF', border: 'none' }}>Orchestrator Account</Button>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Button className="w-100" onClick={() => window.location.replace(clientConfig.ssoPath)} style={{ backgroundColor: '#0AAEEF', border: 'none' }}>Microsoft 365 SSO</Button>
                </Col>
            </Row>
        </div>
    } else if (mode === 'local') {
        return <Signin imgUrl={img}></Signin>
    }
    throw new Error('Unknown signin mode ' + mode);
}

export default LoginScreen;